import { vendorMasterSeed } from './vendors';

/** In-memory Vendor Master store (UI mock — shared by list + detail). */
let vendors = vendorMasterSeed.map((v) => ({ ...v }));

export function getVendors() {
  return vendors;
}

export function setVendors(next) {
  vendors = next;
}

export function addVendor(vendor) {
  vendors = [...vendors, vendor];
  return vendor;
}

export function findVendorById(vendorId) {
  return vendors.find((v) => v.vendorId === vendorId) || null;
}

export function findVendorByPortalToken(token) {
  if (!token) return null;
  return vendors.find((v) => v.portalToken && v.portalToken === token) || null;
}

export function updateVendor(vendorId, patch) {
  vendors = vendors.map((v) =>
    v.vendorId === vendorId ? { ...v, ...patch, vendorId: v.vendorId } : v,
  );
  return findVendorById(vendorId);
}
